import { connect } from 'react-redux';
import { compose, lifecycle, setPropTypes, withHandlers } from 'recompose';
import { fetchOwnerPaymentCard } from '../../main/payment/actions';
import {
  getCardId,
  getPaymentCardBrand,
  getPaymentCardChangeRequired,
  getPaymentCardLast4,
  getPaymentCardUpdatedAt,
} from '../../main/payment/selectors';

const ownerOrCardRequired = (props, propName, componentName) => {
  if ((props.ownerType === undefined || props.ownerId === undefined) && props.card === undefined) {
    return new Error(`Either 'ownerType' and 'ownerId' or 'card' have to be passed in '${componentName}'.`);
  }

  return null;
};
const withFetchOwnerPaymentCard = compose(
  setPropTypes({
    ownerId: ownerOrCardRequired,
    ownerType: ownerOrCardRequired,
    card: ownerOrCardRequired,
  }),
  connect(
    (state, ownProps) => {
      if (ownProps.card === undefined) {
        const cardId = getCardId(state);

        return {
          card: cardId ? {
            id: cardId,
            brand: getPaymentCardBrand(state),
            last4: getPaymentCardLast4(state),
            ownerType: ownProps.ownerType,
            ownerId: ownProps.ownerId,
            paymentCustomerChangeRequired: getPaymentCardChangeRequired(state),
            updatedAt: getPaymentCardUpdatedAt(state),
          } : {
            ownerType: ownProps.ownerType,
            ownerId: ownProps.ownerId,
          },
        };
      }

      return {
        card: {
          ...ownProps.card,
          ownerType: ownProps.card?.ownerType || ownProps.ownerType,
          ownerId: ownProps.card?.ownerId || ownProps.ownerId,
        },
      };
    },
    {
      fetchCard: fetchOwnerPaymentCard,
    }
  ),
  withHandlers({
    fetchCard: props => () => props.fetchCard(props.ownerId, props.ownerType),
  }),
  lifecycle({
    componentDidMount() {
      if (this.props.ownerId !== undefined && this.props.ownerType !== undefined) {
        this.props.fetchCard();
      }
    },
  }),
);

export default withFetchOwnerPaymentCard;
